import { sizer } from "layout/styles/styled/sizer";
import styled from "styled-components";

const StyledMessageWrapper = styled.div<{
  showAdditionalDetailsSection: boolean;
}>`
  margin-bottom: ${sizer(4)};
  font-weight: 500;
  font-size: 18px;
  display: flex;
  width: 100%;
  justify-content: ${({ showAdditionalDetailsSection }) =>
    showAdditionalDetailsSection ? "flex-start" : "center"};
`;

export function Message({
  eligibilityMessage,
  showAdditionalDetailsSection,
}: {
  eligibilityMessage: string;
  showAdditionalDetailsSection: boolean;
}) {
  return (
    <StyledMessageWrapper
      showAdditionalDetailsSection={showAdditionalDetailsSection}
    >
      <p style={{ color: "#ff0000" }}>{eligibilityMessage}</p>
    </StyledMessageWrapper>
  );
}
